import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

type DialogOptions = {
  width: number;
  zIndex: number;
  noConfirm: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationDialog',
  setup(__props, { expose }) {

const dialog = ref<boolean>(false);
const resolve = ref<unknown | null>(null);
const reject = ref<unknown | null>(null);
const title = ref<string | null>(null);
const message = ref<string | null>(null);
const cancel = ref<string | null>(null);
const confirm = ref<string | null>(null);
const dialogOptions = ref<DialogOptions>({
  width: 498,
  zIndex: 3000,
  noConfirm: false,
});

const open = (titleKey: string, msgKey: string, cancelKey: string, confirmKey: string, options?: DialogOptions) => {
  dialog.value = true;
  title.value = titleKey;
  message.value = msgKey;
  cancel.value = cancelKey;
  confirm.value = confirmKey;
  dialogOptions.value = Object.assign(dialogOptions.value, options);

  return new Promise((responseResolve, responseReject) => {
    resolve.value = responseResolve;
    reject.value = responseReject;
  });
};

const onConfirm = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  resolve.value(true);
  dialog.value = false;
};

const onCancel = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  resolve.value(false);
  dialog.value = false;
};

expose({ open });

return { __sfc: true,dialog, resolve, reject, title, message, cancel, confirm, dialogOptions, open, onConfirm, onCancel }
}

})